<template>
  <section class="row">
    <div class="col-12 col-md-9 mx-auto">
      <v-input
        input-id="equipment-fix-content"
        label="Valeur du matériel fixe"
        error-message="La valeur du matériel fixe doit être inférieure ou égale à 500 000 €"
        mask="currency"
        module-name="contract"
        getter-name="get"
        setter-name="updateSubscription"
        :getter-function="getFixeContent"
        :input-validation="validateFixContent"
        path="risk.equipment.fixContent"
        placeholder="10 000"
      />
    </div>
  </section>
</template>
<script>
import { get } from 'lodash-es';
import { validateFixContent } from '@/utils/validators';

import Input2 from '@/components/common/input/Input2.vue';

export default {
  components: {
    'v-input': Input2,
  },
  methods: {
    validateFixContent,
    getFixeContent(contract) {
      return get(contract, 'risk.equipment.fixContent', null);
    },
  },
};
</script>
